import { Radio } from '@customerio/pluma-components/react';

type SendFrequencyRadiosProps = {
  /** The connector's `resolution`: `false` sends once, `true` sends every time. */
  resolution: boolean;
  isDisabled: boolean;
  onChange: (resolution: boolean) => void;
};

/**
 * The send-frequency choice, without a legend — the connectors word that
 * differently, so each form supplies its own.
 */
export function SendFrequencyRadios({ resolution, isDisabled, onChange }: SendFrequencyRadiosProps) {
  return (
    <>
      <Radio
        id="resolution_first_time"
        name="resolution"
        label="Send only the first time the event occurs"
        isChecked={!resolution}
        isDisabled={isDisabled}
        onCheckedChange={() => onChange(false)}
      />
      <Radio
        id="resolution_every_time"
        name="resolution"
        label="Send every time the event occurs"
        isChecked={resolution}
        isDisabled={isDisabled}
        onCheckedChange={() => onChange(true)}
      />
    </>
  );
}
